export default __webpack_public_path__ + "static/media/cup.svg";